import { render, staticRenderFns } from "./HolidaysList.vue?vue&type=template&id=5f2cacda&scoped=true&"
import script from "./HolidaysList.vue?vue&type=script&lang=js&"
export * from "./HolidaysList.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysList.vue?vue&type=style&index=0&id=5f2cacda&lang=scss&scoped=true&"
import style1 from "./HolidaysList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2cacda",
  null
  
)

export default component.exports